import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-list-form-cd001-tab-preLimpeza',
    templateUrl: './list-form-cd001-tab-preLimpeza.component.html'
})

export class ListFormCd001TabPreLimpezaComponent implements OnInit {

    public isVisiblePreLimpeza: boolean;
    public isVisibleClassificacao: boolean;
    public isVisibleRepasse: boolean;

    // tslint:disable-next-line: max-line-length
    constructor() {
    }

    async ngOnInit(): Promise<void> {
        await this.getInit();
    }

    async getTab(tabChoice: number): Promise<void> {
        this.isVisiblePreLimpeza = tabChoice === 1 ? true : false;
        this.isVisibleClassificacao = tabChoice === 2 ? true : false;
    }

    async getInit(): Promise<void> {
        this.isVisiblePreLimpeza = true;
        this.isVisibleClassificacao = false;
        this.isVisibleRepasse = false;
    }
}
